module.exports = __webpack_public_path__ + "img/spear-guanyu.7e50f4eb.jpg";